<template>
  <div class="card" v-if="indexation">
    <div class="pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content pd-40px">
        <p class="is-size-3 has-text-weight-bold mgb-20px has-text-centered">
          {{ $t('indexation.popUpAddIndexation.title')}}
        </p>
        <error-msg-component :messages="messages"
                             :error="error"
                             :champsVide="champsVide"
                             :messagesChampsVide="messagesChampsVide"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = false"/>
        <div class="columns">
          <b-field :label="$t('indexation.popUpAddIndexation.year')"
                   class="column is-4 obligatoire">
            <b-input v-model="indexation.annee" type="number"></b-input>
          </b-field>
          <b-field :label="$t('indexation.popUpAddIndexation.dateDebut')"
                   class="column is-4 obligatoire">
            <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          v-model="indexation.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('indexation.popUpAddIndexation.dateFin')"
                   class="column is-4 obligatoire">
            <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          v-model="indexation.dateFin"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <footer>
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal mgl-0"
            @click="$parent.close()">
            {{ $t('general.button.cancel')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="addIndexation">
            {{ $t('general.button.sauvegarder')}}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import genererIndexation from '@/services/parametrage/indexation/genererIndexation';
import formatIsoDate from '@/services/general/formatIsoDate';
import { create } from '@/api/indexation';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import validationIndexation from '@/services/parametrage/indexation/validation';
import translate from '@/services/parametrage/indexation/translate';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import messageSucces from '@/services/general/messageSucces';

export default {
  props: {
    societeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      indexation: null,
      error: false,
      champsVide: [],
      messagesChampsVide: [],
      messages: [],
    };
  },
  components: {
    ErrorMsgComponent,
  },
  methods: {
    async addIndexation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        const indexation = cloneDeep(this.indexation);
        indexation.dateDebut = formatIsoDate(indexation.dateDebut);
        indexation.dateFin = formatIsoDate(indexation.dateFin);
        await create(indexation);
        this.$emit('reloadAndUpdateYearSelected', this.indexation.annee);
        messageSucces(this.$i18n.t('indexation.message.success.create'));
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationIndexation(e.response, this.messages);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.indexation = genererIndexation(this.societeId);
  },
};

</script>
